import { Component, EventEmitter, OnInit, OnDestroy, Input, Output, ViewChild } from '@angular/core';
import { SubSink } from 'subsink2';
import { combineLatest, forkJoin, iif, Observable, of, zip } from 'rxjs';
import { catchError, exhaustMap, map, mergeMap } from 'rxjs/operators';
import { Pagination, bl_fi_generic_doc_hdr_RowClass, GenericDocHdrService, LocationService, DocumentShortCodesClass } from 'blg-akaun-ts-lib';
import { AppConfig } from '../../visa';
import { PaginationComponent } from '../../utilities/pagination/pagination.component';
import { formatMoneyInList } from '../../format.utils';
import moment from 'moment';

@Component({
  selector: 'app-doc-link-ko-for',
  templateUrl: './doc-link-ko-for.component.html',
  styleUrls: ['./doc-link-ko-for.component.css']
})
export class DocLinkKoForComponent implements OnInit, OnDestroy {

  @Input() localState: any;
  @Input() hdr: bl_fi_generic_doc_hdr_RowClass;
  @Input() service;
  @Input() serverDocTypeDoc1: string;
  @Input() store;
  @Input() GenDocActions;
  @Input() draftStore;
  @Input() LinkActions;
  @Input() LinkSelectors;
  @Input() PNSActions;
  @Input() PNSSelectors;
  @Input() selectedLineItem$: Observable<any>;
  @Input() links$: Observable<any>;
  @Input() AppletConstants;
  @Input() additionalColDef;


  @Output() addKO = new EventEmitter();
  @Output() showDetails = new EventEmitter();

  protected subs = new SubSink();
  
  gridApi;
  enableListing;
  draftLinks: Map<any, any>; draftPNS;
  draftLinksIds = []; draftPNSIds = [];
  knockoffTrigger = false; // An indicator to refresh server data
  itemGuid;
  showCondition: string;

  
  apiVisa = AppConfig.apiVisa;

  @ViewChild(PaginationComponent) paginationComp: PaginationComponent;

  defaultColDef = {
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: { suppressFilterButton: true },
    minWidth: 200,
    flex: 2,
    sortable: true,
    resizable: true,
    suppressCsvExport: true
  };
  
  columnsDefs = [
    {
      headerName: "Doc Short Code",
      field: "server_doc_type",
      maxWidth: 130,
      cellStyle: () => ({ "text-align": "left" }),
      valueFormatter: (params) => params.value ? DocumentShortCodesClass.serverDocTypeToShortCodeMapper(params.value) : "",
    },
    { headerName: 'Doc No.', field: 'doc_number', cellStyle: () => ({ 'text-align': 'left' }), maxWidth: 100 },
    // { headerName: 'Server Doc Type', field: 'server_doc_type', cellStyle: () => ({ 'text-align': 'left' }) },    
    { headerName: 'Txn Date', field: 'date_txn', cellStyle: () => ({ 'text-align': 'left' }), maxWidth: 100, 
      valueFormatter: params => params.value ? moment(params.value).format('YYYY-MM-DD') : null },
    { headerName: 'UOM', field: 'uom', cellStyle: () => ({ 'text-align': 'left' }), maxWidth: 100 },
    { headerName: 'Unit Price (Inc. of Tax)', field: 'unit_price_txn', type: 'numericColumn', maxWidth: 150,
      valueFormatter: (params) => params.value ? formatMoneyInList(params.value) : null },
    // { headerName: 'Base Qty.', field: 'order_qty', type: 'numericColumn', maxWidth: 100 },
    // { headerName: 'Bal. Qty.', field: 'open_qty', type: 'numericColumn', maxWidth: 100 },
    { headerName: 'Knocked Off Qty.', field: 'ko_qty', type: 'numericColumn' },
    // { headerName: 'Knocked Off Qty.', field: 'knocked_off_qty', type: 'numericColumn', maxWidth: 100 },
    // { headerName: 'Knockoff Qty.', type: 'numericColumn', maxWidth: 150,
    //   editable: true,
    //   valueGetter: (params) => { return params.data.ko_qty; },
    //   valueSetter: (params) => {
    //     let newKOvalue = parseInt(params.newValue);
    //     let valueChanged = newKOvalue <= params.data.open_qty && newKOvalue >= 0;
    //     if (valueChanged) {
    //       params.data.ko_qty = newKOvalue;
    //     }
    //     return valueChanged;
    //   }
    // },
    // { headerName: 'Status', field: 'status', cellStyle: () => ({ 'text-align': 'left' }) }
  ];

  constructor(
    private genDocHdrService: GenericDocHdrService,
    private locationService: LocationService,

    ) {
  }

  ngOnInit() {
    if (this.additionalColDef){
      this.columnsDefs = [...this.columnsDefs, ...this.additionalColDef];
    }

    this.enableListing = ((this.hdr.server_doc_type === "INTERNAL_OUTBOUND_STOCK_TRANSFER" || 
                           this.hdr.server_doc_type === "INTERNAL_INBOUND_STOCK_TRANSFER") &&
                           this.hdr.guid_comp) || 
                          (this.hdr.doc_entity_hdr_guid && this.hdr.guid_comp)

    this.showCondition = (this.hdr.server_doc_type === "INTERNAL_OUTBOUND_STOCK_TRANSFER" || this.hdr.server_doc_type === "INTERNAL_INBOUND_STOCK_TRANSFER")? 
                        'location sending and location receiving':
                        'an entity and a branch';
    
    this.subs.sink = this.draftStore.select(this.LinkSelectors.selectLinkState).subscribe(
      resolve => {
        this.draftLinks = resolve.entities;
        this.draftLinksIds = resolve.ids;
      }
    );
    this.subs.sink = this.draftStore.select(this.PNSSelectors.selectPNSState).subscribe(
      resolve => {
        this.draftPNS = resolve.entities;
        this.draftPNSIds = resolve.ids;
      }
    );
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridApi.closeToolPanel();
    this.setGridData();
  }

  setGridData() {
    const datasource = {
      getRows: grid => {
        // console.log("combinelatest check selectedLineitem", this.selectedLineItem$);
        this.subs.sink = combineLatest([this.selectedLineItem$, this.links$]).pipe(
          mergeMap(([a, b]) => {
            // console.log("a,b doc link:", a, b)
            const source: Observable<any>[] = [];
            let match = false;
            b.forEach(link => {
              if (
                link.status !== "DRAFT_TEMP" &&
                link.status !== "DELETED" &&
                link.guid_doc_2_line === a.guid &&
                link.server_doc_type_doc_2_line === this.AppletConstants.docType &&
                link.server_doc_type_doc_1_line === this.serverDocTypeDoc1
              ) {
                match = true;
                const pagination = new Pagination();
                pagination.sortCriteria.push(
                  { columnName: 'doc_entity_hdr_guid', value: this.hdr.doc_entity_hdr_guid? this.hdr.doc_entity_hdr_guid.toString():'' },
                  { columnName: 'guid_comp', value: this.hdr.guid_comp? this.hdr.guid_comp.toString():'' },
                  { columnName: 'line_guids', value: link.guid_doc_1_line },
                  { columnName: 'guids', value: link.guid_doc_1_hdr }
                )
                source.push(
                  zip(
                    // Get source document no.
                    this.genDocHdrService.getByGuid(link.guid_doc_1_hdr.toString(), this.apiVisa).pipe(
                      catchError((err) => of(err))
                    ),
                    // Get line item details
                    <Observable<any>>this.service.getGenericDocHdrLineLinkByCriteria(pagination, this.apiVisa).pipe(
                      catchError((err) => of(err))
                    )
                  ).pipe(map(([hdr, line]) => {
                    // console.log("this is ko for service:",this.service)
                    // console.log("this is ko for hdr",hdr)
                    // console.log("this is ko for line", line)
                    let line1 = line?.data?.filter(a => a.bl_fi_generic_doc_line.guid === link.guid_doc_1_line)[0];
                    this.itemGuid = line1?.bl_fi_generic_doc_line?.item_guid;
                    let temp = Object.assign({
                      guid: link.guid,
                      item_guid: line1.bl_fi_generic_doc_line.item_guid,
                      doc_number: hdr.data.bl_fi_generic_doc_hdr.server_doc_1,
                      server_doc_type: link.server_doc_type_doc_1_line,
                      uom: line1.bl_fi_generic_doc_line.uom,
                      unit_price_txn: line1?.bl_fi_generic_doc_line?.unit_price_txn,
                      date_txn: link.date_txn,
                      ko_qty: Number(link.quantity_contra),
                      tracking_id: line1?.bl_fi_generic_doc_line?.tracking_id,
                      guid_store: line1?.bl_fi_generic_doc_line?.guid_store,
                      guid_store_2: line1?.bl_fi_generic_doc_line?.guid_store_2
                    }, { link: link });
                    // console.log('link object: ', temp);
                    return temp;
                  })
                ));
              }
            });
            return iif(() => match,
              forkJoin(source).pipe(map((b_inner) => {
                b = b_inner;
                return b
              })),
              of([])
            );
          }),
          exhaustMap((a) => {
            const source: Observable<any>[] = [];
            const dataExists = a.length > 0;

            a.forEach(temp => {              
                source.push(
                  zip(
                    // Get source document no.
                    this.locationService.getByGuid(temp?.guid_store?.toString(), this.apiVisa).pipe(
                      catchError((err) => of(err))
                    ),
                    // Get line item details
                    this.locationService.getByGuid(temp?.guid_store_2?.toString(), this.apiVisa).pipe(
                      catchError((err) => of(err))
                    ),
                  ).pipe(map( ([loc_1, loc_2]) => {
                    let newTemp = Object.assign({
                      location1: loc_1.error? '' : loc_1.data.bl_inv_mst_location.name,
                      location2: loc_2.error? '' : loc_2.data.bl_inv_mst_location.name,
                    }, temp);
                    return newTemp;               
                  }))
                );
              
            });
            return iif(() => dataExists,
              forkJoin(source).pipe(map((b_inner) => {
                a = b_inner;
                return a
              })),
              of([])
            );
          })
        ).subscribe(resolved => {
          // console.log("resolved doc link:", resolved)
          grid.success({
            rowData: resolved,
            rowCount: resolved.length
          });
        }, err => {
          console.log(err);
        });
      }
    }
    this.gridApi.setServerSideDatasource(datasource);
  }

  onRowClicked(item) {
    // console.log(item);
    this.showDetails.emit(
      {
        item: item,
        store: this.store,
        GenDocActions: this.GenDocActions,
        itemGuid: this.itemGuid,
        service: this.service,
        serverDocTypeDoc1: this.serverDocTypeDoc1
      }
    );    
  }

  onAdd() {
    this.addKO.emit(
      {
        store: this.store,
        GenDocActions: this.GenDocActions,
        itemGuid: this.itemGuid,
        service: this.service,
        serverDocTypeDoc1: this.serverDocTypeDoc1
      }
    );
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

}
